import { useEffect } from 'react';

export type EffectFunction = () => void | (() => void);

// This exists so we can mock it in tests and run effects by name
export const useNamedEffect = (name: string, effect: EffectFunction, dependencies: any[]) => {
  useEffect(effect, dependencies);
};
